// extracted by mini-css-extract-plugin
export default {"p_content":"_82b8e469c9"};